import sanitizeData from '../utils/sanitizeData'

const asyncExpensesReducer = (state = '', action) => {
  switch (action.type) {
    case 'SET_DATA':
      return { ...state, expensesData: sanitizeData(action.payload) }
    default:
      return state
  }
}

export { asyncExpensesReducer }
